import "./style.scss";
import { useState } from "react";
import { universityProgramsTabs, universityProgramsEducation, universityProgramsQualification } from "@/src/constants/university-programs";
import Tabs from "@/src/components/Tabs/Tabs";
import UniversityProgramsContent from "./UniversityProgramsContentDesk/UniversityProgramsContentDesk";

const UniversityProgramsDesk = () => {
  const [currentTab, setCurrentTab] = useState<string>("bachelor");
  const [universityCardName, setUniversityCardName] = useState(universityProgramsEducation[0].name);

  const handleTabChange = (tabId: string) => {
    setCurrentTab(tabId);
    switch (tabId) {
      case "bachelor":
        setUniversityCardName(universityProgramsEducation[0].name);
        break;
      case "masters":
        setUniversityCardName(universityProgramsQualification[0].name);
        break;
    }
  };

  return (
    <div className="university-programs container">
      <div className="university-programs-header">
        <Tabs title="Программы" tabs={universityProgramsTabs} currentTab={currentTab} setCurrentTab={handleTabChange} />
      </div>
      <div className="university-programs-body">
        <UniversityProgramsContent
          content={currentTab === "bachelor" ? universityProgramsEducation : universityProgramsQualification}
          universityCardName={universityCardName}
          setUniversityCardName={setUniversityCardName}
        />
      </div>
    </div>
  );
};

export default UniversityProgramsDesk;
